(function () {
  function updateCartBubble(itemCount) {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var wrapper = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (itemCount > 0 && !wrapper) {
      return; // Dawn will rebuild bubble on next full cart render; skip silently.
    }
    if (bubble) bubble.textContent = itemCount;
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBubble(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function removeFromCart(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('remove failed');
      return r.json();
    });
  }

  document.querySelectorAll('[data-gc2-toggle-row]').forEach(function (row) {
    var input = row.querySelector('[data-gc2-toggle-input]');
    var variantId = row.dataset.variantId;
    input.addEventListener('change', function () {
      input.disabled = true;
      var request = input.checked ? addToCart(variantId) : removeFromCart(variantId);
      request
        .then(function () { refreshCartCount(); })
        .catch(function () { input.checked = !input.checked; })
        .finally(function () { input.disabled = false; });
    });
  });

  document.querySelectorAll('[data-gc2-crosssell-row]').forEach(function (row) {
    var btn = row.querySelector('[data-gc2-quick-add]');
    var label = row.querySelector('[data-gc2-add-label]');
    var variantId = row.dataset.variantId;
    if (!btn) return;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      addToCart(variantId)
        .then(function () {
          label.textContent = 'Added';
          refreshCartCount();
          setTimeout(function () {
            label.textContent = '+ Add';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          label.textContent = '+ Add';
          btn.disabled = false;
        });
    });
  });

  // Same-day dispatch cut-off. Before it: "Order within 3h 12m for dispatch
  // today". After it, there is nothing honest to count down to, so say when
  // the order will go out instead of showing a 20-hour timer.
  document.querySelectorAll('[data-gc2-countdown]').forEach(function (el) {
    var hour = parseInt(el.dataset.hour, 10);
    if (isNaN(hour)) hour = 16;
    var minute = parseInt(el.dataset.minute, 10) || 0;
    var textEl = el.querySelector('[data-gc2-countdown-text]');
    if (!textEl) return;

    function tick() {
      var now = new Date();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0);
      var diffMs = cutoff - now;
      if (diffMs <= 0) {
        textEl.textContent = '\u{1F69A} Order now — dispatched tomorrow morning';
        return;
      }
      var h = Math.floor(diffMs / 3600000);
      var m = Math.floor((diffMs % 3600000) / 60000);
      var left = h > 0 ? h + 'h ' + m + 'm' : Math.max(1, m) + 'm';
      textEl.textContent = '\u{1F69A} Order within ' + left + ' for dispatch today';
    }

    tick();
    setInterval(tick, 30000);
  });

  // Next Day Delivery — pincodes eligible for the chargeable NDD add-on.
  // Merchant-supplied list; update this string to add/remove pincodes.
  var NDD_PINCODES = new Set('560032,560064,560065,560103,560036,562107,560062,560108,560109,562106,562166,560049,560088,560089,560090,560107,560076,560068,560114,560005,560006,560046,560083,560081,560099,560011,560029,560041,560069,560091,560004,560018,560019,560015,560057,560007,560008,560038,560042,560017,560071,560059,560060,560043,560102,560105,560078,560111,560067,560115,560075,560093,560082,560116,560045,560070,560085,560035,560034,560095,560077,560002,560009,560053,560048,560074,560037,560033,560084,560021,560079,562130,560003,560020,560055,560080,560012,560054,560094,560072,560073,560010,560086,560096,560058,560016,560113,560024,560063,560001,560051,560900,560028,560050,560056,560110,560061,560098,560087,560117,560092,560097,560023,560040,560104,560047,560066,560025,560027,560030,560013,560022,743291,743292,743411,743412,743422,743427,743428,743429,600076,600099,600020,600025,600036,600085,600090,600050,600053,600058,600054,600062,600071,600010,600023,600040,600102,600001,600009,600104,600003,600007,600084,600030,600101,600106,600044,600047,600064,600132,600006,600034,600015,600016,600032,600045,600046,600059,600063,600078,600083,600051,600060,600118,600125,600128,600037,600095,600013,600021,600081,600055,600002,600008,600031,600004,600028,600061,600091,600117,600129,603103,603112,600043,600070,600074,600075,600100,600069,600011,600039,600038,600049,600082,600110,600056,600122,600012,600066,600052,600067,600126,600130,600131,600119,600123,600124,600077,600019,600057,600068,600103,600096,600097,600017,600033,600035,600005,600014,600018,600086,600024,600026,600094,600087,600089,600116,600022,600042,600088,600092,600093,600107,600041,600115,600072,602024,600073,500079,500097,500010,500015,502032,500017,500047,500006,500056,500062,500094,500103,500031,500086,500091,500058,500112,500012,500064,500042,500054,500034,500026,500061,500009,500011,500050,500005,500092,500098,500048,500083,500087,500060,500033,500096,500032,500111,500055,500043,500088,501301,500230,500027,500029,501505,500037,500085,500081,500052,500077,500014,500067,500100,500084,500035,500068,500102,500072,500108,501218,500024,500036,500110,500040,500051,500076,500075,500089,500104,501506,501510,500004,500022,500041,500028,500057,500049,500114,500090,500016,500082,500030,500013,500044,500020,500080,500023,500059,500003,500025,500019,500046,500008,500002,500065,500066,500053,500069,500038,500073,500007,500039,500070,500074,700144,743330,743363,743387,743610,743613,713421,713423,713424,713427,713142,722201,722205,711303,711306,711413,711103,711104,711109,711110,711111,711112,700017,700019,700049,700051,700110,700111,700112,700113,700114,700115,700116,700117,700134,700056,700057,700058,700083,700109,711107,711201,711202,711203,711204,711205,711206,711227,700020,700025,700026,700137,700138,743318,743312,743329,743376,700029,700033,700045,700068,700095,700039,700046,700100,711302,711304,711313,711317,711411,700028,700030,700065,700074,700077,700035,700036,700050,700076,700090,700108,743377,743503,743513,743609,700094,700152,700157,700159,700162,700001,700005,700006,700007,700062,711101,711102,700009,700011,700054,700067,700048,700055,700089,700101,700021,700022,700023,700027,700043,700052,700059,700079,700080,700081,700129,700130,700131,700132,700133,700155,700158,700139,700140,700141,700142,700143,711113,711403,711405,711409,700018,700024,700044,700066,700010,700015,700085,700105,700012,700013,700069,700072,700073,700047,700070,700086,700092,700096,700136,700161,700084,700103,700149,700151,700153,700154,700156,700160,700163,700014,700016,700071,700087,700034,700038,700053,700060,700088,700135,700099,700107,711105,711106,711108,711114,700064,700097,700098,700106,700008,700061,700063,700104,700002,700003,700004,700037,700145,700146,700147,700148,700150,700091,700102,700031,700032,700042,700075,700078,700118,700119,700120,700121,700122,700123,700040,700041,700082,700093,743331,743332,743368,743375,711115,712245,712304,712310,712311,712702,712232,712233,712234,712235,712246,712248,712249,712250,712258,700124,700125,700126,700127,700128,721211,721212,721222,721232,743222,743223,743233,743249,743252,743263,743268,743271,743272,743287,743289,743438,743704,711315,711316,743130,743134,743135,743136,743145,743165,743166,743193,741221,741234,741235,741245,741246,741248,741249,741250,741251,741252,743122,743123,743125,743126,743127,743128,743129,743133,743144,743194,743247,743273,743286,712124,712125,712201,712202,712203,712204,712221,712222,712223,712101,712102,712103,712104,712105,712121,712123,712136,712137,712138,712139,712148,712502,712503,400605,400708,421501,421502,421505,421506,421102,421503,400050,400052,400054,400706,400042,400078,401101,401105,401106,400091,400092,400010,400027,400067,400024,400071,400074,400085,400068,400103,401201,401202,401207,400088,400094,421302,400017,400612,421201,421203,400002,400003,400009,400607,400615,400001,400005,400020,400021,400032,400701,400075,400077,400063,400065,400097,400102,421301,400066,400101,400167,400076,400079,400083,410206,410210,421202,400709,400710,400070,400086,400013,400018,400025,400028,400030,400016,400064,400095,400043,400089,401305,400059,400072,400084,400087,401107,400080,400081,400082,400057,400069,400093,400096,400099,400004,400007,400034,401203,401209,401304,400614,421204,400104,410209,410218,400705,400029,400051,400055,400098,400008,400011,400012,400014,400015,400031,400033,410208,400601,400608,400609,400610,421306,421605,421001,421002,421103,401205,401208,400703,401301,401302,401303,421305,421308,421311,421004,421005,400602,400603,400604,400606,412105,411045,411008,411021,411018,411026,411039,411078,411001,411011,411042,411033,411035,412308,411003,411007,411012,411020,411067,411013,411028,411057,411046,411023,411024,411025,411004,411038,411032,411047,412201,412307,411005,411016,411036,411002,411030,411009,411037,411043,411017,411022,411040,411060,412101,412208,412216,411027,411034,411061,411019,411044,411062,411070,411041,411051,411068,411048,411015,411031,411014,412207,411052,411058,411006,741201,741202,741222,741232,741247,741254,741255,741256,741501,722101,722102,722122,722144,722147,713203,713204,713205,713207,713208,713209,713213,713215,713216,713330,713332,713334,713336,713337,713370,713373,713301,713303,713304,713305,713325,713326,713340,713341,713361,713371,754010,754011,751019,751020,751028,751030,751005,751016,751021,751023,754005,754006,754013,751003,751008,751011,751012,751013,751015,751022,751029,751033,751002,751006,751009,751014,751018,751017,751024,751031,751001,751004,751007,751010,751025,751026,751034,751032,752100,752101,753001,753002,753008,753009,753014,753015,753003,753004,753006,753007,753010,753011,753012,753013,753016,754001,754002,754003,752054,752050,752055,752056,752057,752060,754021,754022,754025,754026,754028,754071,754131,754200,754202,754203,754293,713201,713202,713206,713210,713211,713212,713214,713101,713102,713103,713104,641107,641653,641697,641011,641013,641025,641040,641043,641108,641032,641050,641201,642109,641017,641022,641029,641030,641031,641034,641038,641010,641008,641021,641023,641024,641042,641111,641014,641048,641062,641103,641407,641005,641016,641033,641004,641009,641012,641015,641018,641028,641036,641037,641044,641045,641006,641027,641035,641049,641001,641002,641003,641007,641026,641039,641041,641046,641105,641112,641401,641402,641658,641659,641663,641668,570007,570010,570011,570029,570019,570002,570012,570016,570017,570020,570027,570030,570032,800002,800015,800021,800022,800028,801506,800020,800026,800027,800030,800001,800013,800017,800019,800007,800008,800009,800012,801503,801105,801505,801507,800010,800011,800024,800003,800004,800005,800006,800016,800014,800023,800025,636008,636002,636009,636010,636201,636203,636307,636308,636001,636003,636006,636015,636004,636005,636007,636016,636017,636030,636302,734011,734012,734013,734014,734421,734004,734005,734002,734003,734009,734001,734006,734008,641603,641652,641605,641665,641687,641666,641601,641602,641604,641606,641607,201312,203201,110012,110028,110060,110033,110036,110082,110052,110044,110042,110090,110094,110084,110074,110071,110091,110045,110080,201004,201005,201006,110078,110075,110077,110031,110032,201310,110095,110046,110058,110048,110065,110007,110004,110005,110106,110110,110124,110086,110099,110003,110011,110023,110051,110013,110014,110024,110026,110035,110200,110015,110102,110119,110093,110064,110096,119199,110009,110054,110043,110072,110073,110019,110020,110069,201020,201021,201309,110008,110092,110063,110087,110034,110027,110056,110085,110089,110021,110022,110029,110066,110037,110038,110061,110097,110062,110076,110049,110088,110018,110059,124599,110053,121004,121001,121007,121012,121014,121015,121009,121010,121002,121003,121008,121013,121006,122002,122008,122010,201003,201017,201013,201014,201002,201001,201010,201011,201018,201019,201007,201012,201009,201016,122505,122004,122005,122199,122001,122051,122052,122099,122017,122006,122014,122210,122009,122011,122230,122003,122007,122015,122016,203208,201318,201308,201311,201305,201315,201304,201306,201303,201313,201316,201307,201301,201317,282010,283105,282001,282008,282002,282005,282009,282007,282003,282004,282006,305001,305004,305005,305006,202002,202122,202001,202140,202118,301001,301023,301030,248143,248145,311001,311011,125061,127021,127027,127031,127032,127111,127309,127311,334004,334006,334001,334002,334003,334401,334402,334403,160025,160036,160001,160002,160009,160017,160018,160019,160020,160022,160030,160043,160047,134105,134107,134108,134109,134112,134113,134114,134116,134117,160101,160102,160055,160059,160071,160062,160011,160012,160014,160015,160023,160103,248008,248003,248195,248002,248018,248001,248005,248012,248014,248019,248121,248004,248009,248010,248013,248171,248007,248015,249001,249124,248006,248146,248140,263139,263141,125001,125004,125011,125005,125006,125007,125044,342008,302018,302001,302017,302002,302003,302005,302099,302020,302013,302039,302004,302022,302033,302034,302016,302044,302019,302015,302021,302049,144001,144002,144008,144021,144027,342005,342006,342007,342011,342026,342304,208002,208003,208012,208011,208014,208023,208001,208004,208007,208008,208010,208005,208019,208024,208025,208026,248115,132001,132022,132023,323601,324001,324002,324007,324008,324003,324004,324005,324006,324009,324010,136038,136118,136119,136131,226004,226024,226018,226002,226014,226025,226027,226029,226401,226013,226031,226201,226202,226019,226028,226020,226001,226006,226007,226010,226501,226015,226016,226203,226021,226022,226026,226030,226301,226302,226303,226005,226011,226017,226008,226111,226003,226009,226012,226023,141123,141013,141116,141010,141011,141008,141110,142027,141001,141004,141005,141015,141007,141014,141016,342001,342002,342003,281001,281121,281406,281003,281004,281006,281305,250001,250003,250004,244001,251001,251003,132103,132105,132106,132108,132145,123101,123102,123401,124001,124010,124021,247666,247667,263153,247669,247001,247002,203001,203002,203150,249205,249410,249411,331001,331031,332311,332312,332315,332317,332001,331403,331411,249401,249404,249408,304001,304021,304022,304801,244103,244105,313001,313004,313002,135001,135002,135003,135004,135101,211001,211014,211017,211018,211019,221505,221507,211016,211003,211007,211008,211010,211012,211015,211013,212502,212503,211002,211006,212105,211004,211011,211021,211023,143001,143022,143116,143002,143005,143006,143008,143009,143105,276001,276125,276135,221004,221011,221108,221311,221001,221007,221112,221005,221109,221010,221103,221106,221002,221003'.split(','));
  var NDD_VARIANT_ID = '59782878232862'; // "Next Day Delivery (Add-on)" – Rs. 99

  // Two dispatch cutoffs per day for Next Day Delivery. The countdown
  // always rolls forward to whichever is next (11:00 AM -> 4:00 PM -> next
  // day's 11:00 AM -> ...); NDD stays orderable the whole time a pincode is
  // eligible — there's no dead "expired, come back tomorrow" state anymore.
  var NDD_CUTOFFS = [
    { hour: 11, minute: 0, label: '11:00 AM' },
    { hour: 16, minute: 0, label: '4:00 PM' }
  ];

  function getNextNddCutoff() {
    var now = new Date();
    for (var i = 0; i < NDD_CUTOFFS.length; i++) {
      var c = NDD_CUTOFFS[i];
      var candidate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), c.hour, c.minute, 0, 0);
      if (candidate > now) return { date: candidate, label: c.label };
    }
    var first = NDD_CUTOFFS[0];
    var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, first.hour, first.minute, 0, 0);
    return { date: tomorrow, label: first.label };
  }

  document.querySelectorAll('[data-gc2-pincode]').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-gc2-pincode-input]');
    var btn = wrapper.querySelector('[data-gc2-pincode-check]');
    var result = wrapper.querySelector('[data-gc2-pincode-result]');
    var nddRow = wrapper.querySelector('[data-gc2-ndd-row]');
    var nddInput = wrapper.querySelector('[data-gc2-ndd-input]');
    var nddTitle = wrapper.querySelector('[data-gc2-ndd-title]');
    var nddSubtitle = wrapper.querySelector('[data-gc2-ndd-subtitle]');
    var nddMessage = wrapper.querySelector('[data-gc2-ndd-message]');
    var nddCongrats = wrapper.querySelector('[data-gc2-ndd-congrats]');
    var nddTimer = wrapper.querySelector('[data-gc2-ndd-timer]');
    var congratsTimer = null;
    var nddTimerInterval = null;
    var pincodePattern = /^[1-9][0-9]{5}$/;

    // Live serviceability + zone lookup via a Cloudflare Worker proxy that
    // holds the Delhivery API key server-side (it can't live in this file —
    // theme JS is fully visible in page source). See delhivery-proxy-worker/.
    var WORKER_URL = 'https://dark-flower-d8ca.chamanranga.workers.dev/';
    var LIVE_TIMEOUT_MS = 6000;

    // Fallback zone table, used only if the live Worker call fails or times
    // out (network issue, Worker/Delhivery downtime), so the checker still
    // gives a reasonable estimate instead of breaking. Dispatch origin: Delhi.
    var DIGIT_ZONE = {
      '2': 'B', // Uttar Pradesh, Uttarakhand
      '3': 'C', // Rajasthan, Gujarat, Daman & Diu, Dadra & Nagar Haveli
      '8': 'C', // Bihar, Jharkhand
      '5': 'E', // Telangana, Andhra Pradesh, Karnataka
      '6': 'E', // Tamil Nadu, Kerala, Puducherry, Lakshadweep
      '9': 'E'  // Army Postal Service
    };

    function zoneForDigit1(value) {
      var prefix3 = parseInt(value.slice(0, 3), 10);
      if (prefix3 >= 180 && prefix3 <= 194) return 'C'; // J&K, Ladakh
      if (prefix3 >= 171 && prefix3 <= 177) return 'B'; // Himachal Pradesh
      return 'A'; // Delhi, Haryana, Punjab, Chandigarh
    }

    function zoneForDigit4(value) {
      var prefix2 = parseInt(value.slice(0, 2), 10);
      if (prefix2 >= 45 && prefix2 <= 49) return 'C'; // Madhya Pradesh, Chhattisgarh
      return 'D'; // Maharashtra, Goa
    }

    function zoneForDigit7(value) {
      var prefix3 = value.slice(0, 3);
      if (prefix3 === '737' || prefix3 === '744') return 'E'; // Sikkim, Andaman & Nicobar
      var prefix2 = parseInt(value.slice(0, 2), 10);
      if (prefix2 >= 70 && prefix2 <= 77) return 'D'; // West Bengal, Odisha
      return 'E'; // Assam, Arunachal Pradesh, Meghalaya, Manipur, Mizoram, Nagaland, Tripura
    }

    var ZONE_INFO = {
      A: { label: 'Zone A', region: 'Delhi NCR & Plains North', days: '1–2 days' },
      B: { label: 'Zone B', region: 'North India', days: '2–3 days' },
      C: { label: 'Zone C', region: 'West, Central & East India', days: '3–4 days' },
      D: { label: 'Zone D', region: 'West & East India', days: '4–5 days' },
      E: { label: 'Zone E', region: 'South India, North-East & Islands', days: '6–7 days' }
    };

    function zoneForPincode(value) {
      var firstDigit = value.charAt(0);
      if (firstDigit === '1') return zoneForDigit1(value);
      if (firstDigit === '4') return zoneForDigit4(value);
      if (firstDigit === '7') return zoneForDigit7(value);
      return DIGIT_ZONE[firstDigit] || 'E';
    }

    function showResult(message, isSuccess) {
      result.textContent = message;
      result.classList.remove('is-success', 'is-error');
      result.classList.add('is-visible', isSuccess ? 'is-success' : 'is-error');
    }

    function triggerCongrats() {
      if (!nddCongrats) return;
      nddCongrats.hidden = false;
      nddCongrats.classList.remove('is-animating');
      void nddCongrats.offsetWidth; // force reflow so the animation restarts every time
      nddCongrats.classList.add('is-animating');
      clearTimeout(congratsTimer);
      congratsTimer = setTimeout(function () {
        nddCongrats.hidden = true;
        nddCongrats.classList.remove('is-animating');
      }, 2500);
    }

    function stopNddTimer() {
      if (nddTimerInterval) { clearInterval(nddTimerInterval); nddTimerInterval = null; }
      if (nddTimer) nddTimer.hidden = true;
    }

    function startNddTimer() {
      if (!nddTimer) return;
      nddTimer.hidden = false;
      if (nddTimerInterval) return;

      function tick() {
        if (nddRow.dataset.gc2NddState !== 'available') { stopNddTimer(); return; }
        var next = getNextNddCutoff();
        var msLeft = next.date - new Date();
        if (msLeft <= 0) { return; } // will resolve to the following cutoff on the next tick
        var h = Math.floor(msLeft / 3600000);
        var m = Math.floor((msLeft % 3600000) / 60000);
        var s = Math.floor((msLeft % 60000) / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        nddTimer.textContent = '⏰ Order within ' + pad(h) + ':' + pad(m) + ':' + pad(s) + ' for Next Day Delivery (next cutoff ' + next.label + ')';
      }

      tick();
      nddTimerInterval = setInterval(tick, 1000);
    }

    function setNddState(state) {
      if (!nddRow) return;
      var previousState = nddRow.dataset.gc2NddState;
      nddRow.dataset.gc2NddState = state;
      nddRow.classList.remove('is-locked', 'is-unavailable', 'is-available', 'is-expired');
      nddRow.classList.add('is-' + state);
      if (nddTitle && nddSubtitle) {
        if (state === 'available') {
          nddTitle.textContent = 'Next Day Delivery available!';
          nddSubtitle.textContent = '+₹99 — get it delivered tomorrow';
        } else if (state === 'unavailable') {
          nddTitle.textContent = 'Next Day Delivery';
          nddSubtitle.textContent = 'Not available for this pincode';
        } else {
          nddTitle.textContent = 'Next Day Delivery';
          nddSubtitle.textContent = 'Check your pincode above to see if this is available';
        }
      }
      if (nddMessage) { nddMessage.hidden = true; nddMessage.textContent = ''; }
      if (state !== 'available' && nddInput && nddInput.checked) {
        nddInput.checked = false;
        removeFromCart(NDD_VARIANT_ID).then(refreshCartCount).catch(function () {});
      }
      if (state === 'available') {
        startNddTimer();
        if (previousState !== 'available') triggerCongrats();
      } else {
        stopNddTimer();
      }
    }

    function updateNddForPincode(value) {
      if (!nddRow) return;
      setNddState(NDD_PINCODES.has(value) ? 'available' : 'unavailable');
    }

    function showStaticEstimate(value) {
      var zone = ZONE_INFO[zoneForPincode(value)];
      showResult(
        '✅ Delivery available at ' + value + ' (' + zone.label + ' – ' + zone.region + '). ' +
        'Estimated delivery: ' + zone.days + ' from dispatch (Delhi). Cash on Delivery available in most areas.',
        true
      );
      updateNddForPincode(value);
    }

    function checkLive(value) {
      if (btn) { btn.disabled = true; btn.dataset.originalLabel = btn.textContent; btn.textContent = 'Checking...'; }

      var controller = ('AbortController' in window) ? new AbortController() : null;
      var timeoutId = setTimeout(function () { if (controller) controller.abort(); }, LIVE_TIMEOUT_MS);

      fetch(WORKER_URL + '?pincode=' + value, controller ? { signal: controller.signal } : {})
        .then(function (r) {
          if (!r.ok) throw new Error('worker_error');
          return r.json();
        })
        .then(function (data) {
          if (data.serviceable === false) {
            showResult('Sorry, we currently do not deliver to ' + value + '.', false);
            setNddState('unavailable');
            return;
          }
          if (!data.serviceable || !data.estimatedDays) throw new Error('unexpected_response');

          var codText = data.cod
            ? 'Cash on Delivery available.'
            : 'Cash on Delivery not available for this pincode — prepaid only.';
          var place = data.city ? ' (' + data.city + (data.state ? ', ' + data.state : '') + ')' : '';

          showResult(
            '✅ Delivery available at ' + value + place + '. ' +
            'Estimated delivery: ' + data.estimatedDays + ' from dispatch (Delhi). ' + codText,
            true
          );
          updateNddForPincode(value);
        })
        .catch(function () {
          showStaticEstimate(value);
        })
        .finally(function () {
          clearTimeout(timeoutId);
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalLabel || 'Check'; }
        });
    }

    function check() {
      var value = (input.value || '').trim();
      if (!pincodePattern.test(value)) {
        showResult('Please enter a valid 6-digit pincode.', false);
        setNddState('locked');
        return;
      }
      checkLive(value);
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '').slice(0, 6);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        check();
      }
    });

    if (btn) btn.addEventListener('click', check);

    if (nddInput) {
      nddInput.addEventListener('change', function () {
        var state = nddRow ? nddRow.dataset.gc2NddState : 'locked';
        if (state !== 'available') {
          nddInput.checked = false;
          if (nddMessage) {
            nddMessage.hidden = false;
            nddMessage.textContent = state === 'locked'
              ? 'Please check your pincode above for serviceability first.'
              : "Next Day Delivery isn't available for your pincode.";
          }
          return;
        }
        nddInput.disabled = true;
        var request = nddInput.checked ? addToCart(NDD_VARIANT_ID) : removeFromCart(NDD_VARIANT_ID);
        request
          .then(function () { refreshCartCount(); })
          .catch(function () { nddInput.checked = !nddInput.checked; })
          .finally(function () { nddInput.disabled = false; });
      });
    }
  });
})();
